module.exports = __webpack_public_path__ + "static/interview-f748bb3b9db2d972a9613eae82c81598.svg";